module.exports = __webpack_public_path__ + "static/media/CC10-ETH.92a69505.png";